import { SIMULATION_SIZES } from './constants.js';

export const SIZE_FIELDS = { P: 'quantity_p', M: 'quantity_m', L: 'quantity_l', XL: 'quantity_xl', '2XL': 'quantity_2xl', '3XL': 'quantity_3xl', '4XL': 'quantity_4xl', '5XL': 'quantity_5xl' };
// The current process setting takes precedence; the saved flag is a fallback
// for historical lines whose process relation is no longer available.
export const processLines = (product) => (product.cost_lines || [])
  .filter((line) => line.line_type === 'process' && !(line.process?.excludes_manufacturing ?? line.excludes_manufacturing))
  .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0) || String(a.id).localeCompare(String(b.id)));
export const matrixTotal = (rows = []) => rows.reduce((total, row) => total + SIMULATION_SIZES.reduce((sum, size) => sum + Number(row[SIZE_FIELDS[size]] || 0), 0), 0);
export function matrixModel(rows = []) {
  const quantities = {}, contrasts = {};
  for (const row of rows) {
    for (const size of SIMULATION_SIZES) quantities[`${row.color}::${size}`] = Number(row[SIZE_FIELDS[size]] || 0);
    contrasts[row.color] = { contrast_1: row.contrast_1 || '', contrast_2: row.contrast_2 || '', contrast_3: row.contrast_3 || '' };
  }
  return { colors: rows.map((row) => row.color), quantities, contrasts };
}
export function initialMatrix(product) {
  if (!product.editColors) return product.color_lines || [];
  return product.editColors.map((color, sort_order) => ({ ...(product.color_lines || []).find((row) => row.color === color), color, sort_order, ...product.editContrasts?.[color], ...Object.fromEntries(SIMULATION_SIZES.map((size) => [SIZE_FIELDS[size], Number(product.editQuantities?.[`${color}::${size}`] || 0)])) }));
}
export function processMatrix(product, line) {
  let previous = initialMatrix(product);
  for (const process of processLines(product)) {
    previous = process.received_matrix ?? previous;
    if (process.id === line.id) return previous.map((row) => ({ ...row }));
  }
  return [];
}
export function quantityWarnings(product, line) {
  const lines = processLines(product), index = lines.findIndex((p) => p.id === line.id);
  const expected = index === 0 ? matrixTotal(initialMatrix(product)) : lines[index - 1]?.received_quantity;
  const hasValue = (value) => value !== null && value !== undefined && value !== '';
  const total = matrixTotal(processMatrix(product, line));
  return {
    delivered: hasValue(line.delivered_quantity) && hasValue(expected) && Number(line.delivered_quantity) !== Number(expected),
    received: hasValue(line.received_quantity) && Number(line.received_quantity) !== total,
    expected, matrixTotal: total,
    deliverySource: index === 0 ? 'matriz inicial' : 'cantidad recibida del proceso anterior',
  };
}
export const processStatus = (line) => line.received_date ? 'Finalizado' : 'En proceso';
export function validateProcessTracking(products) {
  for (const product of products) for (const line of processLines(product)) {
    if (line.delivered_date && line.received_date && line.received_date < line.delivered_date) return `${line.name_snapshot}: la recepción no puede ser anterior a la entrega.`;
    for (const field of ['delivered_quantity', 'received_quantity']) {
      const value = line[field];
      if (value !== null && value !== undefined && value !== '' && (!Number.isSafeInteger(Number(value)) || Number(value) < 0)) return `${line.name_snapshot}: las cantidades deben ser números enteros positivos o cero.`;
    }
  }
  return null;
}
export function receivedInvoiceAmounts(process, materials = []) {
  const quantity = Number(process.received_quantity);
  if (process.received_quantity === null || process.received_quantity === undefined || !Number.isSafeInteger(quantity) || quantity <= 0) throw new Error('Indica una cantidad recibida mayor que cero antes de facturar.');
  const amount = (line) => Number((quantity * Number(line.quantity_per_unit || 0) * (line.line_type === 'material' ? 1 + Number(line.waste_pct || 0) / 100 : 1) * Number(line.unit_cost || 0)).toFixed(4));
  return { quantity, processAmount: amount(process), materialAmounts: materials.map(amount) };
}
